// Locales
import ptBR from './pt-BR';
import es from './es';
import en from './en';
import ptPT from './pt-PT';

export default {
  'pt-BR': ptBR,
  es,
  en,
  'pt-PT': ptPT
};
